export const GET_JACKTOP_TOKEN = 'GET_JACKTOP_TOKEN';
export const SUCCESS_GET_JACKTOP_TOKEN = 'SUCCESS_GET_JACKTOP_TOKEN';
export const FAILURE_GET_JACKTOP_TOKEN = 'FAILURE_GET_JACKTOP_TOKEN';


// WEBPACK FOOTER //
// ./js/actions/jacktopGames/jacktopGames.js